<template v-slot:default="{ hide }">
    <div class="px-3 py-2 filter-wrapper">

        <div v-for="(row1, index) in company_options" :key="index">
            <div v-if="row1.options.length == 0 && default_column.includes(row1.label)">
                <label>{{stringView(row1.label)}}</label>
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" :placeholder="stringView(row1.label)" :name="row1.label" v-model="search_by_filter[row1.label]"></b-form-input>
                </b-input-group>
            </div>
        </div>

        <!-- Mustafijur: CHANGED: replaced select multiple with checkbox dropdown (row2 - filter_by_id) -->
        <div v-for="(row2, index2) in company_options" :key="row2.label">
            <div v-if="row2.options.length > 0 && default_column.includes(row2.label)">
                <label><template v-if="row2.label == 'jobposition'">Job Position</template><template v-else>{{stringView(row2.label)}}</template></label>
                <div v-if="filter_by_id.includes(row2.label)">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <!-- <select :name="row4.label" class='form-control' v-model="search_by_filter[row4.label+'_id']" multiple>
                            <option value='' >Select {{stringView(row4.label)}}</option>
                            <option v-for='data in row4.options' :value='data.id' :key="data.id+data.name">{{ data.name }}</option>
                        </select> -->

                        <!-- Mustafijur: CHANGED: was <select multiple> -->
                        <div class="checkbox-dropdown flex-grow-1" :ref="'dd_row2_id_'+row2.label">
                            <button type="button" class="form-control dd-trigger" @click="toggleDropdown('row2_id_'+row2.label)">
                                <span :class="(search_by_filter[row2.label+'_id'] && search_by_filter[row2.label+'_id'].length) ? 'dd-selected' : 'dd-placeholder'">
                                     <!-- Mustafijur: 24-06-2026: added template job position pf_unified -->
                                    <template>
                                        {{ (search_by_filter[row2.label+'_id'] && search_by_filter[row2.label+'_id'].length) ? getSelectedNames(row2.options, search_by_filter[row2.label+'_id'], true) : (row2.label == 'jobposition' ? 'Job Position' : stringView(row2.label)) }}
                                    </template>
                                    <!-- <template>
                                        {{ (search_by_filter[row2.label+'_id'] && search_by_filter[row2.label+'_id'].length) ? getSelectedNames(row2.options, search_by_filter[row2.label+'_id'], true) : stringView(row2.label) }}
                                    </template> -->
                                    <!-- Mustafijur: 24-06-2026: added template job position pf_unified -->
                                </span>
                                <!-- <b-icon class="ml-3 dd-arrow" icon="caret-down-fill"></b-icon> -->
                                <b-icon class="ml-3 dd-arrow" icon="chevron-down" scale="1.2"></b-icon> <!-- Mustafijur: unified: 02-08-2026: changed icon and scale.-->
                            </button>
                            <div class="dd-menu" v-if="openDropdown == 'row2_id_'+row2.label">
                                <label v-for="data in row2.options" :key="data.id+data.name" class="dd-item">
                                    <input type="checkbox" :value="data.id" v-model="search_by_filter[row2.label+'_id']" />
                                    {{ data.name }}
                                </label>
                            </div>
                        </div>
                        <!-- Mustafijur: END CHANGED -->
                    </b-input-group>
                </div>
                <div v-else>
                    <!-- <label>{{stringView(row2.label)}}</label> --> <!-- Mustafijur: Commented -->
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <!-- <select multiple :name="row2.label" class='form-control' v-model='search_by_filter[row2.label]'>

                            <option v-for='data in row2.options' :value='data.id' :key="data.id+data.name">{{ data.name }}</option>
                        </select> -->

                        <!-- Mustafijur: CHANGED: was <select multiple> -->
                        <div class="checkbox-dropdown flex-grow-1" :ref="'dd_row2_'+row2.label">
                            <button type="button" class="form-control dd-trigger" @click="toggleDropdown('row2_'+row2.label)">
                                <span :class="(search_by_filter[row2.label] && search_by_filter[row2.label].length) ? 'dd-selected' : 'dd-placeholder'">
                                    {{ (search_by_filter[row2.label] && search_by_filter[row2.label].length) ? getSelectedNames(row2.options, search_by_filter[row2.label], false) : stringView(row2.label) }}
                                </span>
                                <!-- <b-icon class="ml-3 dd-arrow" icon="chevron-down" scale="1.2"></b-icon> -->
                                <b-icon class="ml-3 dd-arrow" icon="chevron-down" scale="1.2"></b-icon> <!-- Mustafijur: unified: 02-08-2026: changed icon and scale.-->
                            </button>
                            <div class="dd-menu" v-if="openDropdown == 'row2_'+row2.label">
                                <label v-for="data in row2.options" :key="data.id+data.name" class="dd-item">
                                    <input type="checkbox" :value="data.id" v-model="search_by_filter[row2.label]" />
                                    {{ data.name }}
                                </label>
                            </div>
                        </div>
                        <!-- Mustafijur: END CHANGED -->
                    </b-input-group>
                </div>
            </div>
        </div>

        <div v-for="(row3, index4) in company_options" :key="row3.label+index4">
            <div v-if="row3.options.length == 0 && column_selected.includes(row3.label) && row3.type !='date'">
                <label><template v-if="row3.label == 'nid'">NID</template><template v-else-if="row3.label == 'etin'">e-TIN</template><template v-else>{{ stringView(row3.label) }}</template></label>
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" :placeholder="stringView(row3.label)" :name="row3.label" v-model="search_by_filter[row3.label]"></b-form-input>
                </b-input-group>
            </div>
            <div v-if="row3.options.length == 0 && column_selected.includes(row3.label) && row3.type =='date'">
                <label>{{ stringView(row3.label) }}</label>
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input :placeholder="stringView(row3.label)+' (From)'" :name="row3.label+'-from'" v-model="search_by_filter[row3.label+'_from']"></b-form-input>
                    <b-input-group-append>
                        <b-form-datepicker id="day_one" button-only right locale="en-US" v-model="search_by_filter[row3.label+'_from']"></b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input :placeholder="stringView(row3.label)+' (To)'" :name="row3.label+'-to'" v-model="search_by_filter[row3.label+'_to']"></b-form-input>
                    <b-input-group-append>
                        <b-form-datepicker id="day_two" button-only right locale="en-US" :min="search_by_filter[row3.label+'_from']" v-model="search_by_filter[row3.label+'_to']"></b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
            </div>
        </div>

        <!-- Mustafijur: CHANGED: replaced select multiple with checkbox dropdown (row4) -->
        <div v-for="(row4, index3) in company_options" :key="index3+row4.label">
            <div v-if="row4.options.length > 0 && column_selected.includes(row4.label)">
                <div v-if="filter_by_id.includes(row4.label)">
                    <label><template v-if="row4.label == 'jobposition'">Job Position</template><template v-else>{{stringView(row4.label)}}</template></label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                         <!-- <select multiple :name="row4.label" class='form-control' v-model="search_by_filter[row4.label+'_id']">

                            <option v-for='data in row4.options' :value='data.id' :key="data.id+data.name">{{ data.name }}</option>
                        </select> -->

                        <!-- Mustafijur: CHANGED: was <select multiple> -->
                        <div class="checkbox-dropdown flex-grow-1" :ref="'dd_row4_id_'+row4.label">
                            <button type="button" class="form-control dd-trigger" @click="toggleDropdown('row4_id_'+row4.label)">
                                <span :class="(search_by_filter[row4.label+'_id'] && search_by_filter[row4.label+'_id'].length) ? 'dd-selected' : 'dd-placeholder'">
                                    {{ (search_by_filter[row4.label+'_id'] && search_by_filter[row4.label+'_id'].length) ? getSelectedNames(row4.options, search_by_filter[row4.label], false) : (row4.label == 'jobposition' ? 'Job Position' : stringView(row4.label)) }}
                                </span>
                                <!-- <b-icon class="ml-3 dd-arrow" icon="caret-down-fill"></b-icon> -->
                                <b-icon class="ml-3 dd-arrow" icon="chevron-down" scale="1.2"></b-icon> <!-- Mustafijur: unified: 02-08-2026: changed icon and scale.-->
                            </button>
                            <div class="dd-menu" v-if="openDropdown == 'row4_id_'+row4.label">
                                <label v-for="data in row4.options" :key="data.id+data.name" class="dd-item">
                                    <input type="checkbox" :value="data.id" v-model="search_by_filter[row4.label+'_id']" />
                                    {{ data.name }}
                                </label>
                            </div>
                        </div>
                        <!-- Mustafijur: END CHANGED -->
                    </b-input-group>
                </div>
                <div v-else>
                    <label>{{stringView(row4.label)}}</label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <!-- <select multiple :name="row4.label" class='form-control' v-model='search_by_filter[row4.label]'>

                            <option v-for='data in row4.options' :value='data.name' :key="data.id">{{ data.name }}</option>
                        </select> -->
                        <!-- Mustafijur: CHANGED: was <select multiple> -->
                        <div class="checkbox-dropdown flex-grow-1" :ref="'dd_row4_'+row4.label">
                            <button type="button" class="form-control dd-trigger" @click="toggleDropdown('row4_'+row4.label)">
                                <span :class="(search_by_filter[row4.label] && search_by_filter[row4.label].length) ? 'dd-selected' : 'dd-placeholder'">
                                    {{ (search_by_filter[row4.label] && search_by_filter[row4.label].length) ? getSelectedNames(row4.options, search_by_filter[row4.label], false) : stringView(row4.label) }}
                                </span>
                                <!-- <b-icon class="ml-3 dd-arrow" icon="caret-down-fill"></b-icon> -->
                                <b-icon class="ml-3 dd-arrow" icon="chevron-down" scale="1.2"></b-icon> <!-- Mustafijur: unified: 02-08-2026: changed icon and scale.-->
                            </button>
                            <div class="dd-menu" v-if="openDropdown == 'row4_'+row4.label">
                                <label v-for="data in row4.options" :key="data.id" class="dd-item">
                                    <input type="checkbox" :value="data.name" v-model="search_by_filter[row4.label]" />
                                    {{ data.name }}
                                </label>
                            </div>
                        </div>
                        <!-- Mustafijur: END CHANGED -->
                    </b-input-group>
                </div>
            </div>
        </div>

        <div class="mt-4 row">
            <div class="col-6">
                <b-button class="filter_btn" v-b-toggle.sidebar_right variant="primary" block title="Set Filter"><div>Set Filter</div></b-button>
            </div>
            <div class="col-6">
                <b-button class="filter_btn" variant="primary" block title="Clear Filter" @click="resetFlter();"><div>Clear Filter</div></b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: ['company_options','search_by_filter','column_selected','default_column'],

        data(){
            return {
                filter_by_id:['jobposition','department','employee_type','branch', 'blood_group'],
                filter_by_id_options:[{jobposition:"jobposition_id"},{department:"department_id"},{employee_type:"employee_type_id"},{branch:"branch_id"},{blood_group:"blood_group_id"}],
                openDropdown: null, // Mustafijur: CHANGED: tracks which dropdown is open
            }
        },
        methods:{

            // Mustafijur: CHANGED: new method to toggle checkbox dropdowns
            toggleDropdown(key) {
                this.openDropdown = this.openDropdown == key ? null : key;
            },

            // Mustafijur: CHANGED: now shows "Dept, Role +2 more" instead of full overflowing list
            getSelectedNames(options, selectedValues, useId) {
                if (!selectedValues || !selectedValues.length) return '';
                const names = options
                    .filter(o => selectedValues.includes(useId ? o.id : o.name))
                    .map(o => o.name);
                if (names.length <= 2) return names.join(', ');

                return names.slice(0, 2).join(', ') + ` +${names.length - 2} more`;
            },

            // Mustafijur: CHANGED: new method - close dropdown when clicking outside
            handleOutsideClick(e) {
                const dropdowns = document.querySelectorAll('.checkbox-dropdown');
                let clickedInside = false;
                dropdowns.forEach(dd => { if (dd.contains(e.target)) clickedInside = true; });
                if (!clickedInside) this.openDropdown = null;
            },
            // Mustafijur: END CHANGED

            generateFilterOptions: function() {
                let value = [];
                value['reset'] = 0;
                value['search_by_filter'] = this.search_by_filter;
                this.$emit('childToParent',value);
            },
            stringView(str) {
                const labelMap = { 'jobposition': 'Job Position' };
                if (labelMap[str]) return labelMap[str];
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            // resetFlter: function()
            // {
            //     let value = [];
            //     value['reset'] = 1;
            //     let cr = this.search_by_filter;
            //     let defaultval = {};
            //     Object.keys(this.search_by_filter).forEach(key => {

            //         defaultval[key] = '';
            //     });
            //     value['search_by_filter'] = defaultval;
            //     this.$emit('childToParent',value);
            // },

            // Mustafijur: CHANGED: reset array fields to [] instead of '' to fix checkbox select-all bug after reset
            resetFlter: function() {
                let value = [];
                value['reset'] = 1;
                let defaultval = {};
                Object.keys(this.search_by_filter).forEach(key => {
                    defaultval[key] = Array.isArray(this.search_by_filter[key]) ? [] : '';
                });
                value['search_by_filter'] = defaultval;
                this.$emit('childToParent', value);
            },
        },
        // Mustafijur: CHANGED: mount/destroy outside click listener
        mounted() {
            document.addEventListener('click', this.handleOutsideClick);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleOutsideClick);
        },
        // Mustafijur: END CHANGED

        created: function() {
            this.generateFilterOptions();
        }
    }
</script>

<!-- Mustafijur: CHANGED: all new styles for checkbox dropdown -->
<style scoped>
.checkbox-dropdown {
    position: relative;
}
.dd-trigger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    cursor: pointer;
    background: #fff;
    /* height: 38px; */
    overflow: hidden;
    min-width: 0;
    /* border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important; */
    /* max-width: 271px; */
    max-width: 100%;
}
.dd-placeholder {
    color: #aaa;
    /* font-size: 13px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 20px);
    display: block;
}
.dd-selected {
    /* font-size: 13px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 20px);
    display: block;
}
.dd-arrow {
    font-size: 10px;
    color: #aaa;
    flex-shrink: 0;
    margin-left: 6px;
}
.dd-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 999;
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    max-height: 200px;
    overflow-y: auto;
}
.dd-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    /* font-size: 13px; */
    cursor: pointer;
    margin: 0;
    font-weight: normal;
}
.dd-item:hover {
    background: #f5f5f5;
}
.dd-item input[type=checkbox] {
    accent-color: #3490dc;
    width: 14px;
    height: 14px;
    cursor: pointer;
    flex-shrink: 0;
}

.checkbox-dropdown {
    position: relative;
    min-width: 0;
}
.filter-wrapper .input-group {
    flex-wrap: nowrap;
}
.dd-placeholder,
.dd-selected {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}

</style>
